import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'recompose';

export default propName => {
  const mapStateToProps = (state, { match: { params } }) =>
    propName ? { [propName]: params } : params;

  return compose(
    withRouter,
    connect(mapStateToProps),
  );
};
